import type { SpidrRow } from '../routes/security-focuses/$focusID/components/security-focus-spidrs-table';

export const expiringStates = ['Delivered', 'Complete'];

export const sortOutcomeExpirationColumn = (aRow: SpidrRow, bRow: SpidrRow) => {
  if (
    expiringStates.includes(aRow.state) &&
    !expiringStates.includes(bRow.state)
  ) {
    return -1;
  } else if (
    !expiringStates.includes(aRow.state) &&
    expiringStates.includes(bRow.state)
  ) {
    return 1;
  }

  // Sort on Spidrs that have a set expiration.
  if (aRow.doesBlueprintExpire && !bRow.doesBlueprintExpire) {
    return -1;
  } else if (!aRow.doesBlueprintExpire && bRow.doesBlueprintExpire) {
    return 1;
  }

  // Sort on the Spidr expiry date.
  if (
    aRow.nullableExpiryDate &&
    bRow.nullableExpiryDate &&
    aRow.nullableExpiryDate.getTime() < bRow.nullableExpiryDate.getTime()
  ) {
    return -1;
  } else if (
    aRow.nullableExpiryDate &&
    bRow.nullableExpiryDate &&
    aRow.nullableExpiryDate.getTime() > bRow.nullableExpiryDate.getTime()
  ) {
    return 1;
  }

  return 0;
};
